import { type FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type PlantTypeText } from '@common/types/plant';
import { H2 } from '@components/Typography/Typography';
import { Close } from '@components/ui/Close/Close';

import { type GoodsType } from '@/common/types/goods';

import { ModalContext } from '../Modal/config';

import { BuyInfo } from './BuyInfo/BuyInfo';
import { ConfirmBuy } from './ConfimBuy/ConfirmBuy';

import css from './styles.module.scss';

interface BoostProductionProps {
  material: PlantTypeText | GoodsType;
  plantId: string;
}

const BoostProduction: FC<BoostProductionProps> = ({ material, plantId }) => {
  const { closeModal } = useContext(ModalContext);
  const [isConfirm, setIsConfirm] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="w-full relative">
      <div className={css.gradient}></div>
      <Close
        onClick={closeModal}
        className={css.close}
        imageVariant="modal"
        variant="modal"
      />
      <div className="w-full h-full flex flex-col items-center pb-4 pt-[1.875rem]">
        <H2 weight="bold" className="!text-white/40 mb-[1.875rem]">
          {t('Instant completion')}
        </H2>
        {isConfirm ? (
          <ConfirmBuy material={material} plantId={plantId} />
        ) : (
          <BuyInfo
            setIsConfirm={setIsConfirm}
            material={material}
            plantId={plantId}
          />
        )}
      </div>
    </div>
  );
};

export { BoostProduction };
